module.exports = __webpack_public_path__ + "29aade1802805f2adceda20018849f0e.svg";